<template>
  <div id="BillDetail">
    <subTitle :title="isResell === 1 ? $t('转售记录') : $t('授权记录')"></subTitle>

    <div class="open-table-search">
      <div class="open-table-search-list">
        <span class="search-text">{{ isResell === 1 ? $t('转售开始时间') : $t('授权开始时间') }}</span>
        <es-date-picker v-model="search.startTime" type="date" value-format="timestamp" :clearable="false" class="search-fun">
        </es-date-picker>
      </div>
      <div class="open-table-search-list">
        <span class="search-text">{{ isResell === 1 ? $t('转售结束时间') : $t('授权结束时间') }}</span>
        <es-date-picker v-model="search.endTime" type="date" value-format="timestamp" :clearable="false" class="search-fun">
        </es-date-picker>
      </div>
      <div class="open-table-search-list">
        <span class="search-text">{{ $t('授权状态') }}</span>
        <es-select v-model="search.status" :placeholder="$t(`请选择`)" class="search-fun">
          <es-option v-for="(item, index) in statusList" :key="index" :label="item.name" :value="item.val"></es-option>
        </es-select>
      </div>
      <div class="open-table-search-list">
        <span class="search-text">{{ $t('授权方式') }}</span>
        <es-select v-model="search.authType" :placeholder="$t(`请选择`)" class="search-fun">
          <es-option v-for="(item, index) in authTypeList" :key="index" :label="item.name" :value="item.val"></es-option>
        </es-select>
      </div>
      <div class="open-table-search-list">
        <span class="search-text">{{ isResell === 1 ? $t('被转售方名称') : $t('被授权方名称') }}</span>
        <es-input v-model="search.selledName" class="search-fun"></es-input>
      </div>
      <div class="open-table-search-list">
        <span class="search-text">{{ $t('产品名称') }}</span>
        <es-select v-if="isResell === 1" v-model="search.proId" :placeholder="$t(`请选择`)" class="search-fun">
          <es-option v-for="(item, index) in proList" :key="index" :label="item.productName" :value="item.productId"></es-option>
        </es-select>
        <es-select v-if="isResell === 0" v-model="search.proId" :placeholder="$t(`请选择`)" class="search-fun">
          <es-option v-for="(item, index) in proList" :key="index" :label="item.productName" :value="item.productId"></es-option>
        </es-select>
      </div>
      <div class="open-table-search-list" v-if="isResell === 1">
        <span class="search-text">{{ $t('订单编号') }}</span>
        <es-select v-model="search.orderId" :placeholder="$t(`请选择`)" class="search-fun">
          <es-option v-for="(key, value) in orderList" :key="value" :label="key.showId" :value="key.id"></es-option>
        </es-select>
      </div>
      <div class="open-table-search-list" v-else>
        <span class="search-text">{{ $t('订单编号') }}</span>
        <es-input v-model="search.orderId" class="search-fun"></es-input>
      </div>
      <div class="open-table-search-list search-submit">
        <es-button @click="searchList()" type="primary">{{ $t('查询') }}</es-button>
        <es-button variant="outline" @click="clear()">{{ $t('清空') }}</es-button>
      </div>
    </div>
    <divided />

    <div class="common-body">
      <div class="table">
        <es-row class="table-title">
          <es-col :span="2">{{ isResell === 1 ? $t('转售时间') : $t('授权时间') }}</es-col>
          <es-col :span="3">{{ $t('产品名称') }}</es-col>
          <es-col v-if="isResell === 0" :span="3">{{ $t('授权方') }}</es-col>
          <es-col :span="3">{{ isResell === 1 ? $t('主订单号') : $t('订单号') }}</es-col>
          <es-col :span="3">{{ isResell === 1 ? $t('被转售方名称') : $t('被授权方名称') }}</es-col>
          <es-col :span="3">{{ $t('有效期') }}</es-col>
          <es-col :span="1">{{ $t('授权量') }}</es-col>
          <es-col v-if="isResell === 0" :span="1">{{ $t('剩余量') }}</es-col>
          <es-col v-if="isResell === 1 && showLockNum" :span="2">{{ $t('预扣用量') }}</es-col>
          <es-col v-if="isResell === 0" :span="1">{{ $t('状态') }}</es-col>
          <es-col v-if="isResell === 0" :span="1">{{ $t('授权方式') }}</es-col>
          <es-col :span="isResell === 1 ? 4 : 2">{{ $t('操作') }}</es-col>
        </es-row>
        <es-row class="table-main" v-for="(item, index) in list" :key="index">
          <es-col :span="2">{{ isResell === 1 ? formatUtc(item.sellTime) : formatUtc(item.createTime) }}</es-col>
          <es-col :span="3">{{ isResell === 1 ? item.sellProductName : item.productName }}</es-col>
          <es-col v-if="isResell === 0" :span="3">
            {{ item.authGidName }}
          </es-col>
          <es-col :span="3">
            {{ getOrderId(item) }}
          </es-col>
          <es-col :span="3">
            {{ isResell === 1 ? item.selledGidName : item.authedGidName }}
            <es-popover v-if="item.remark" placement="bottom" width="200" trigger="hover" :content="item.remark">
              <i class="es-icon-warning" slot="reference" style="color: #faad14"></i>
            </es-popover>
          </es-col>
          <es-col v-if="isResell === 1" :span="3">
            <span v-if="item.productType == -2">--</span>
            <span v-else> {{ formatUtc(item.effectStartTime, 'day') }} ~ {{ formatUtc(item.effectEndTime, 'day') }} </span>
          </es-col>
          <es-col v-if="isResell === 1" :span="2">
            <span v-if="item.productType == -2">--</span>
            <span v-else-if="item.units === 'G'">{{ showDataUnit(item.consumeAmount, 'floor', item) }}</span>
            <span v-else>{{ `${getShowPrice(item, 'consumeAmount', 'KB', 1)}${getShowUnit(item, 'KB', 1, 'consumeAmount')}` }}</span>
            <span>{{ `/ ${getShowPrice(item, 'sellAmount', 'G')}${getShowUnit(item, 'G')}` }}</span>
          </es-col>
          <es-col v-if="isResell === 0" :span="3">
            <span v-if="item.productType == -2">--</span>
            <span v-else> {{ formatUtc(item.startTime, 'day') }} ~ {{ formatUtc(item.endTime, 'day') }} </span>
          </es-col>
          <es-col v-if="isResell === 0" :span="1">
            <span v-if="item.productType == -2 || item.authType === 0">--</span>
            <span v-else-if="item.units === 'G'">{{ showDataUnit(item.amount, 'floor', item) }}</span>
            <span v-else>{{ getShowPrice(item, 'amount', 'KB', 1) }}{{ getShowUnit(item, 'KB', 1, 'amount') }}</span>
          </es-col>
          <es-col v-if="isResell === 0" :span="1">
            <span :style="{ color: item.authType === 2 && item.consumeInfo?.marginInfo?.num === 0 ? 'red' : '#4b4b4bff' }">
              {{ item.authType === 0 ? '--' : `${item.consumeInfo?.marginInfo?.num || '0'}${item.consumeInfo?.marginInfo?.unit || ''}` }}
            </span>
          </es-col>
          <es-col v-if="isResell === 1 && showLockNum" :span="2">
            {{ item.lockNum + item.units }}
          </es-col>
          <es-col v-if="isResell === 0" :span="1">
            {{ item.status === 1 ? $t('已取消') : $t('授权中') }}
          </es-col>
          <es-col v-if="isResell === 0" :span="1">
            {{ item.authType === 0 ? $t('共享') : $t('配额') }}
          </es-col>
          <es-col v-if="isResell === 1" :span="4">
            <es-button type="text" @click="showOpenServer(item, true)" v-if="item.webParameter.openChild">{{ $t('开通') }}</es-button>
            <es-button type="text" @click="showOpenServer(item, false)" v-if="item.saleType === 2">{{ $t('查看') }}</es-button>
            <es-button type="text" @click="openPrompt(item)">{{ $t('备注') }}</es-button>
            <es-button type="text" v-if="item.isDeliver" @click="openLogisticInfo(item)">{{ $t('查看物流') }}</es-button>
          </es-col>
          <es-col v-else :span="2">
            <span v-if="item.status === 1">{{ formatUtc(item.cancelTime, 'day') }}</span>
            <es-button type="text" v-if="item.status === 0" @click="cancelAuth(item)">{{ $t('取消') }}</es-button>
            <es-button v-if="isResell === 0" type="text" :disabled="$route.query.disableCheckDebit === 'true'" @click="jumpDetail(item)">
              {{ $t('查看账单') }}
            </es-button>
          </es-col>
        </es-row>

        <es-row class="noData" v-show="list.length === 0">
          <es-empty
            style="margin: 25px; color: #999; line-height: 40px"
            :description="$t(`暂无更多数据`)"
            image="data:image/png;base64,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"
            :image-size="64"></es-empty>
        </es-row>

        <es-dialog :title="$t(`设置备注`)" :visible.sync="dialogFormVisible" class="setRemark" width="460px">
          <es-input v-model="remark" type="textarea" class="remark" :autosize="false" :placeholder="$t(`请输入备注内容`)"></es-input>
          <div class="dialog-footer">
            <es-button type="primary" @click="sure()">{{ $t('确定') }}</es-button>
            <es-button variant="outline" @click="dialogFormVisible = false">{{ $t('取消') }}</es-button>
          </div>
        </es-dialog>

        <es-dialog :title="$t(`开通子服务项`)" :visible.sync="dialogTableVisible" v-if="dialogTableVisible">
          <subServerTable
            :needPassWord="true"
            :orderId="orderId"
            :cakeOrderId="cakeOrderId"
            @getServerData="getServerData"
            @cancle="cancle"
            :isEdit="isEdit"
          ></subServerTable>
        </es-dialog>

        <es-pagination
          style="text-align: right; margin: 20px 0"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          layout="prev, pager, next, jumper"
          v-show="list.length > 0"
          :total="totalItems"
        >
        </es-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { $t } from '@/locales'
import subTitle from '@/components/subTitle'
import { formatUtc, getShowPrice, getShowUnit, showDataUnit } from '@/util.js'
import MD5 from 'js-md5'
import divided from '../../components/divided'

export default {
  components: {
    divided,

    subTitle,
    subServerTable: () => import('@/components/subServerTable.vue'),
  },

  data() {
    return {
      getShowPrice,
      getShowUnit,
      showDataUnit,
      showLockNum: false,
      orderId: '',
      isEdit: false,
      cakeOrderId: '',
      dialogTableVisible: false,
      remark: '',
      dialogFormVisible: false,
      formatUtc,
      gid: this.$route.query.gid,
      isResell: Number(this.$route.query.isResell), // 是否是转售订单记录
      search: {
        proId: Number(this.$route.query.proId) || '',
        orderId: this.$route.query.orderId || '',
        startTime: '',
        endTime: '',
        time: [],
        status: '',
        authType: '',
        selledName: '',
      },
      statusList: [
        {
          name: $t('授权中'),
          val: 0,
        },
        {
          name: $t('已取消'),
          val: 1,
        },
      ],

      currentPage: 1,
      proList: [],
      orderList: [],
      list: [],
      totalItems: 0,
      authTypeList: [
        {
          name: $t('共享'),
          val: 0,
        },
        {
          name: $t('配额'),
          val: 2,
        },
      ],
    }
  },
  methods: {
    jumpDetail(item) {
      if (this.$route.query.disableJump === 'true') {
        return
      }
      const year = new Date().getFullYear()
      const month = new Date().getMonth() + 1
      this.$router.push({
        path: '/BillDetail',
        query: {
          proId: this.$route.query.proId,
          year,
          month,
          orderId: item.authOrderId, // 授权方（主企业）
          authedGid: item.authedGid, // 被授权方（实际使用方 子企业）
        },
      })
    },
    // 获取订单id
    getOrderId(item) {
      return (this.isResell === 1 ? item.showId : item.authOrderShowId) || '-'
    },
    getServerData({ details, signPassword }) {
      const data = {
        childProducts: details,
        infoPwdSign: MD5(signPassword),
      }
      this.$ajax(this.$url.subOpenChilds(this.cakeOrderId), data).then(res => {
        this.dialogTableVisible = false
        this.$message({
          type: 'success',
          message: $t('已成功开通子服务项'),
        })
      })
    },
    cancle() {
      this.dialogTableVisible = false
    },
    showOpenServer({ cakeOrderId, orderId }, isEdit) {
      this.cakeOrderId = cakeOrderId
      this.orderId = orderId
      this.isEdit = isEdit
      this.dialogTableVisible = true
    },
    sure() {
      if (!/^.{1,40}$/.test(this.remark)) {
        this.$message.error($t('最大输入40个字符'))

        return
      }
      this.$ajax(this.$url.addRemark(this.item.cakeOrderId), {
        remark: this.remark,
      }).then(() => {
        this.$message({
          type: 'success',
          message: $t('操作成功'),
        })
        this.dialogFormVisible = false
        this.getList()
      })
    },
    changePro() {
      this.search.orderId = ''
    },
    clear() {
      if (this.isResell === 1) {
        this.search.orderId = ''
        this.search.proId = ''
        this.search.startTime = ''
        this.search.endTime = ''
        this.search.time = []
        this.search.selledName = ''
      } else if (this.isResell === 0) {
        this.search.orderId = ''
        this.search.proId = ''
        this.search.startTime = ''
        this.search.endTime = ''
        this.search.time = []
        this.search.status = ''
        this.search.selledName = ''
        this.search.authType = ''
      }
      this.searchList()
    },
    // 物流信息
    openLogisticInfo(item) {
      this.$router.push({
        path: '/deliveryMage',
        query: {
          orderId: this.search.orderId,
          proId: this.search.proId,
          cakeOrderId: item.cakeOrderId,
        },
      })
    },
    searchList() {
      this.currentPage = 1
      this.getList()
    },
    currentChange(val) {
      this.currentPage = val
      this.getList()
    },
    getList() {
      if (this.isResell === 1) {
        const data = {
          currentPage: this.currentPage,
          itemsPerPage: 10,
          sellOrderId: this.search.orderId,
          sellProductId: this.search.proId,
          startTime: this.search.startTime,
          endTime: this.search.endTime ? this.search.endTime + 24 * 60 * 60 * 1000 - 1 : '',
          selledName: this.search.selledName,
        }
        this.$ajax(this.$url.orderResellRecord(), data).then(res => {
          this.list = res.data.resultList || []
          this.totalItems = res.data.totalItems || 0
          this.showLockNum = this.list.some(item => item.lockNum > 0)
        })
      } else if (this.isResell === 0) {
        // 获取授权记录列表
        const data = {
          currentPage: this.currentPage,
          pageSize: 10,
          authOrderId: this.search.orderId,
          // 产品id字段待定
          authProductId: this.search.proId,
          startTime: this.search.startTime,
          status: this.search.status,
          endTime: this.search.endTime ? this.search.endTime + 24 * 60 * 60 * 1000 - 1 : '',
          authGid: this.gid,
          authedGidName: this.search.selledName,
          authType: this.search.authType,
        }
        this.$ajax(this.$url.orderAuthList(), data).then(res => {
          this.list = res.data || []
          this.totalItems = res.rowCount || 0
        })
      }
    },
    // 获取产品名称列表
    getOrderList() {
      if (this.isResell === 1) {
        this.$ajax(this.$url.queryZSOrder(), {}).then(res => {
          this.orderList = res.data.orderModelList || []
          this.proList = res.data.productList || []
        })
      } else if (this.isResell === 0) {
        this.$ajax(this.$url.getProductList(), {}).then(res => {
          this.proList = res.data.filter(item => item != null)
        })
      }
    },
    openPrompt(item) {
      this.item = item
      this.dialogFormVisible = true
      this.remark = item.remark
    },
    // 取消授权
    cancelAuth(item) {
      this.$confirm(
        $t('请确认是否取消"{slot1}"订单的授权，取消后，收回当前授权量的管理,可能会影响"{slot2}"使用。', {
          slot1: item.productName,
          slot2: item.authedGidName,
        }),
        $t('取消授权'),

        {
          confirmButtonText: $t('确定'),
          cancelButtonText: $t('取消'),
          type: 'warning',
        }
      )
        .then(() => {
          this.$ajax(this.$url.orderAuthDel(item.id), {}).then(res => {
            this.getList()
          })
        })
        .catch(() => {})
    },
  },
  mounted() {
    this.getOrderList()
    this.getList()
  },
}
</script>
<style lang="less" scoped>
.dialog-footer {
  display: flex;
  flex-direction: row-reverse;
  padding-top: 16px;
  /deep/ .es-button {
    margin-left: 8px;
  }
}

/deep/ .es-col {
  word-break: break-all;
}

.load {
  img {
    width: 12px;
    height: 12px;
  }
  span {
    color: #0975e0ff;
    font-size: 14px;
  }
}
.tip {
  margin: 15px 0;
  font-weight: 900;
  color: RGBA(51, 51, 51, 1);
  font-size: 14px;
}
.search-bar {
  color: RGBA(85, 91, 101, 1);
  overflow: hidden;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f3f3f3;
  padding-bottom: 15px;
  > span {
    display: inline-block;
  }
}
.table-main,
.table-title {
  min-height: 40px;
  line-height: 40px;
  color: RGBA(102, 102, 102, 1);
  border-top: 1px solid RGBA(243, 243, 243, 1);
  text-align: left;
  padding-left: 20px;
  background: #f7f8faff;
  display: flex;
  align-items: center;
  :last-child {
    text-align: center;
  }
}
.table-main {
  min-height: 50px;
  line-height: 50px;
  background: #fff;
  border: 1px solid RGBA(236, 241, 246, 1);
  border-top: none;
}
.width120 {
  max-width: 120px;
}
.search-bar {
  .es-row {
    width: 100%;
  }
  .es-col {
    height: 56px;
    display: flex;
    align-items: center;
  }
}
</style>
